<template>
  <div class="container-fluid">
    <div class="card mb-25 border-0 rounded-0 bg-white add-besc-card shadow-sm">
      <!-- Step Progress Tracker -->
      <StepProgressTracker 
        :current-step="'step3'" 
        :besc-id="bescId" 
      />
      
      <div class="card-header d-flex justify-content-between align-items-center py-4 px-4"
        style="background-color: #0a59a4;">
        <div>
          <h3 class="text-white fw-bold mb-1">Étape 3/4 – Documents & Validation finale</h3>
          <small class="text-white opacity-75">Téléversez les documents nécessaires et validez le BESC</small>
        </div>
      </div>

      <div class="card-body p-15 p-sm-20 p-md-30 letter-spacing">
        <div class="border border-primary rounded-3 shadow-sm overflow-hidden">
          <div class="row d-flex align-items-center justify-content-between fw-bold py-3 px-4 m-0"
            style="background-color: #0a59a4;">
            <div class="col-md-7">
              <h5 class="text-white mb-0">Pièce(s) jointe(s)</h5>
            </div>
            <div class="col-md-5 text-end">
              <button type="button" class="btn btn-light btn-sm shadow-sm" @click="addPiece" :disabled="!canAddPiece">
                Ajouter une pièce
              </button>
            </div>
          </div>
          <div class="p-4">
            <div class="row gx-3 mb-3 fw-bold text-muted small">
              <div class="col-md-5">TYPE DE DOCUMENT</div>
              <div class="col-md-5">FICHIER</div>
              <div class="col-md-2 text-center">ACTION</div>
            </div>
            <hr class="mt-0 mb-4">

            <div v-for="(piece, index) in pieces" :key="index"
              class="row gx-3 align-items-center mb-3 pb-3 border-bottom">
              <div class="col-md-5">
                <Multiselect v-model="piece.type_id" :options="typeDocuments" placeholder="Sélectionner le type"
                  label="label" track-by="value" :loading="loading"
                  :class="{ 'border-danger': !piece.type_id && index < pieces.length - 1 }" />
                <small v-if="!piece.type_id && index < pieces.length - 1" class="text-danger">
                  Type de document requis
                </small>
              </div>

              <div class="col-md-5">
                <input type="file" class="form-control shadow-sm"
                  :class="{ 'border-danger': !piece.fichier && index < pieces.length - 1 }"
                  @change="e => handleFile(e, index)" :accept="'.pdf'" />
                <small v-if="piece.filename" class="text-success d-block mt-2">
                  {{ piece.filename }}
                </small>
                <small v-else-if="!piece.fichier && index < pieces.length - 1" class="text-danger d-block mt-1">
                  Fichier requis
                </small>
              </div>

              <div class="col-md-2 text-center">
                <button v-if="index > 0" type="button" class="btn btn-danger btn-sm" @click="removePiece(index)">
                  Supprimer
                </button>
                <span v-else class="text-muted small">—</span>
              </div>
            </div>

            <div v-if="pieces.length === 0" class="text-center text-muted py-4">
              Aucun document ajouté. Cliquez sur "Ajouter une pièce" pour commencer.
            </div>
          </div>
        </div>

        <div v-if="documentManquant.length > 0" class="text-danger mt-3 fw-bold">
          Documents obligatoires manquants :
          <ul>
            <li v-for="type in typeDocuments.filter(t => documentManquant.includes(t.value))" :key="type.value">
              {{ type.label }}
            </li>
          </ul>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-5 pt-4 border-top">
          <router-link :to="{ name: 'AddBlStep2', params: { id: bescId } }" class="btn btn-danger px-4">
            Retour à l'étape 2
          </router-link>
          <!-- <button type="button" @click="saveDraft" class="btn px-5 py-2 text-white"
            style="background-color: #0a59a4; border: none;"
            :disabled="submitting || pieces.length === 0 || !hasAllDocuments">
            <i v-if="submitting" class="fa fa-spinner fa-spin me-2"></i>
            {{ submitting ? 'Finalisation en cours...' : 'Enregistrer le BESC & Soumettre' }}
          </button> -->
          <button type="button" @click="goToRecap" class="btn px-5 py-2 text-white"
            style="background-color: #0a59a4; border: none;" :disabled="pieces.length === 0 || !hasAllDocuments">
           Valider & continuer
          </button>

        </div>
      </div>
    </div>
    <!-- MODAL : Choix du paiement -->
    <div v-if="showPaymentModal" class="modal-backdrop fade show"></div>
    <div v-if="showPaymentModal" class="modal fade show d-block" tabindex="-1" style="z-index: 1050;">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content overflow-hidden"
          style="border-radius: 20px; box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);">
          <div class="payment-modal-container">
            <div class="payment-header">
              <h2> Finaliser votre BESC</h2>
              <p>Paiement sécurisé et rapide</p>
              <div class="amount-display">
                {{ formatEuro(facture?.montantTotal || 0) }}
              </div>
            </div>

            <div class="px-4 pb-4">
              <div class="alert alert-info mb-4">
                <h6 class="mb-2"> Facture : {{ facture?.referenceFacture }}</h6>
                <div class="row small">
                  <div class="col-md-6">
                    <p class="mb-1"><strong>Montant HT :</strong> {{ formatEuro(facture?.subtotalAmount) }}</p>
                    <p class="mb-1"><strong>TVA (18%) :</strong> {{ formatEuro(facture?.taxAmount) }}</p>
                  </div>
                  <div class="col-md-6">
                    <p class="mb-1"><strong>Échéance :</strong> {{ formatDate(facture?.dueDate) }}</p>
                  </div>
                </div>
              </div>

              <div v-if="prepaidAccount" class="alert alert-success small p-3 mb-4">
                <strong>Solde disponible :</strong> {{ formatEuro(prepaidAccount.balance) }}
              </div>

              <div class="payment-methods-title">
                Choisissez votre moyen de paiement
              </div>

              <div class="payment-methods-grid">
                <div v-if="prepaidAccount && prepaidAccount.balance >= facture?.montantTotal"
                  class="payment-method-card recommended" @click="payWithPrepaidAccount" style="cursor: pointer;">
                  <div class="payment-icon-wrapper">
                    <i class="fa fa-wallet fa-3x text-primary"></i>
                  </div>
                  <div class="payment-method-name">Compte Prépayé</div>
                  <div class="payment-method-desc">Solde : {{ formatEuro(prepaidAccount.balance) }}</div>
                </div>

                <div class="payment-method-card recommended" @click="redirectToPaymentMethod('kkiapay')"
                  style="cursor: pointer;">
                  <div class="payment-icon-wrapper">
                    <img src="/kkiapay.png.webp" alt="KkiaPay"
                      style="width: 60px; height: 60px; object-fit: contain;" />
                  </div>
                  <div class="payment-method-name">KkiaPay</div>
                  <div class="payment-method-desc">MTN • Moov • Carte</div>
                </div>

                <div class="payment-method-card" @click="redirectToPaymentMethod('paypal')" style="cursor: pointer;">
                  <div class="payment-icon-wrapper">
                    <img src="/paypal.png.png" alt="PayPal" style="width: 60px; height: 60px; object-fit: contain;" />
                  </div>
                  <div class="payment-method-name">PayPal</div>
                  <div class="payment-method-desc">Compte PayPal</div>
                </div>

                <div class="payment-method-card" @click="redirectToPaymentMethod('stripe')" style="cursor: pointer;">
                  <div class="payment-icon-wrapper">
                    <img src="/stripe.png.png" alt="Stripe" style="width: 60px; height: 60px; object-fit: contain;" />
                  </div>
                  <div class="payment-method-name">Carte Bancaire</div>
                  <div class="payment-method-desc">Visa • Mastercard</div>
                </div>
              </div>

              <div v-if="prepaidAccount && prepaidAccount.balance < facture?.montantTotal"
                class="alert alert-warning mt-4">
                <small>
                  <i class="fa fa-info-circle me-1"></i>
                  Manquant : {{ formatEuro(facture.montantTotal - prepaidAccount.balance) }}
                </small>
              </div>

              <div class="text-center mt-5">
                <button type="button" class="btn btn-outline-secondary btn-lg" @click="cancelPayment">
                  <i class="fa fa-times me-2"></i>
                  Annuler et revenir à la liste
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL : Paiement confirmé → UNIQUEMENT IMPRESSIONS DIRECTES -->
    <div v-if="showSuccessModal" class="modal-backdrop fade show"></div>
    <div v-if="showSuccessModal" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #28a745;">
            <h5 class="modal-title text-white">
              <i class="fa fa-check-circle me-2"></i>
              Paiement confirmé !
            </h5>
          </div>

          <div class="modal-body text-center p-4">
            <p class="mb-4">Votre paiement a été confirmé avec succès.<br>Imprimez vos documents maintenant :</p>

            <div class="d-flex flex-column gap-3">
              <button type="button" class="btn btn-success btn-lg" @click="printBESC" :disabled="printingBESC">
                <i v-if="printingBESC" class="fa fa-spinner fa-spin me-2"></i>
                <i v-else class="fa fa-print me-2"></i>
                {{ printingBESC ? 'Préparation de l\'impression...' : 'Imprimer le BESC' }}
              </button>

              <button type="button" class="btn btn-info btn-lg text-white" @click="printFacture"
                :disabled="printingFacture">
                <i v-if="printingFacture" class="fa fa-spinner fa-spin me-2"></i>
                <i v-else class="fa fa-file-invoice-dollar me-2"></i>
                {{ printingFacture ? 'Préparation de l\'impression...' : 'Imprimer la facture' }}
              </button>

              <button type="button" class="btn btn-outline-primary btn-lg" @click="goToList">
                <i class="fa fa-list me-2"></i>
                Voir la liste des BESC
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Multiselect from '@vueform/multiselect'
import ApiService from '@/services/ApiService'
import { success, error } from '@/utils/utils'
import { bescWizard, resetBescWizard, updateStepProgression, loadBescProgressionFromAPI } from '@/utils/bescWizard'
import Swal from 'sweetalert2'
import StepProgressTracker from '@/components/BESC/StepProgressTracker.vue'

export default defineComponent({
  name: 'AddBescStep3',
  components: { 
    Multiselect,
    StepProgressTracker
  },

  setup() {
    const route = useRoute()
    const router = useRouter()
    const bescId = route.params.id as string

    const typeDocuments = ref<{ value: number; label: string; obligatoire: boolean }[]>([])
    const pieces = bescWizard.step3.pieces
    const submitting = ref(false)
    const loading = ref(false)
    const paying = ref(false)

    // États pour les impressions
    const printingBESC = ref(false)
    const printingFacture = ref(false)

    const showPaymentModal = ref(false)
    const showSuccessModal = ref(false)

    const facture = ref<any>(null)
    const prepaidAccount = ref<any>(null)

    const documentManquant = computed(() => {
      const required = typeDocuments.value.filter(t => t.obligatoire).map(t => t.value)
      const fourni = pieces.map(p => p.type_id)
      return required.filter(r => !fourni.includes(r))
    })

    const hasAllDocuments = computed(() => {
      if (pieces.length === 0) return false
      const allFilled = pieces.every(p => p.type_id && p.fichier)
      if (!allFilled) return false
      return documentManquant.value.length === 0
    })

    const canAddPiece = computed(() => {
      if (pieces.length === 0) return true
      const lastPiece = pieces[pieces.length - 1]
      return !!(lastPiece.type_id && lastPiece.fichier)
    })

    // const goToRecap = () => {
    //   if (!hasAllDocuments.value) {
    //     error('Veuillez ajouter tous les documents requis avant de continuer')
    //     return
    //   }
    //   bescWizard.step3.pieces = pieces.map(p => ({
    //     type_id: p.type_id,
    //     fichier: p.fichier,
    //     filename: p.filename
    //   }))

    //   router.push({ name: 'Recapitulatif', params: { id: bescId } })
    // }

    const goToRecap = async () => {
      if (!hasAllDocuments.value) {
        error('Veuillez ajouter tous les documents requis avant de continuer')
        return
      }

      submitting.value = true
      try {
        await uploadDocuments()
        
        updateStepProgression('step3', true)
        
        router.push({ name: 'Recapitulatif', params: { id: bescId } })
      } catch (err: any) {
        error(err.response?.data?.message || 'Erreur lors de la sauvegarde des documents')
      } finally {
        submitting.value = false
      }
    }

    const loadTypes = async () => {
      loading.value = true
      try {
        const res = await ApiService.get('/typeDocumentBescs')
        typeDocuments.value = res.data.data.data.map((x: any) => ({
          value: x.id,
          label: x.libelle,
          obligatoire: x.obligatoire
        }))
      } catch (err) {
        error('Erreur lors du chargement des types de documents')
      } finally {
        loading.value = false
      }
    }

    const loadPrepaidAccount = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}')
        if (!user.acteurId) return

        const res = await ApiService.get(`/prepaid-accounts/acteur/${user.acteurId}`)
        if (res.data.data) {
          const accounts = Array.isArray(res.data.data) ? res.data.data : [res.data.data]
          const activeAccount = accounts.find((acc: any) => acc.status === 'ACTIVE' && Number(acc.balance) > 0)
          if (activeAccount) prepaidAccount.value = activeAccount
        }
      } catch (err: any) {
        if (err.response?.status !== 404) console.error('Erreur compte prépayé:', err)
      }
    }

    const handleFile = (e: any, index: number) => {
      const file = e.target.files[0]
      if (file) {
        if (file.size > 10 * 1024 * 1024) {
          error('Le fichier ne doit pas dépasser 10 Mo')
          e.target.value = ''
          return
        }
        pieces[index].fichier = file
        pieces[index].filename = file.name
      }
    }

    const addPiece = () => {
      if (!canAddPiece.value) {
        error('Veuillez compléter la pièce actuelle avant d\'en ajouter une nouvelle')
        return
      }
      pieces.push({ type_id: null, fichier: null, filename: '' })
    }

    const removePiece = (index: number) => {
      pieces.splice(index, 1)
    }

    const uploadDocuments = async () => {
      const formData = new FormData()
      pieces.forEach((p) => {
        if (p.type_id) formData.append('type_ids[]', p.type_id.toString())
        if (p.fichier) formData.append('files', p.fichier)
      })
      await ApiService.post(`/besc/${bescId}/documents`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    }

    const saveDraft = async () => {
      if (!hasAllDocuments.value) {
        error('Veuillez ajouter et compléter tous les documents requis')
        return
      }
      submitting.value = true
      try {
        await uploadDocuments()
        const response = await ApiService.post(`/besc/${bescId}/calculate-fees`, {})
        facture.value = response.data.data.facture
        await loadPrepaidAccount()
        showPaymentModal.value = true
      } catch (err: any) {
        error(err.response?.data?.message || 'Erreur lors de la finalisation du BESC')
      } finally {
        submitting.value = false
      }
    }

    const previewDraft = async () => {
      try {
        const response = await ApiService.getFile(`/besc/${bescId}/preview-draft`)
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
        setTimeout(() => window.URL.revokeObjectURL(url), 1000)
      } catch (err: any) {
        error('Impossible de générer l\'aperçu.')
      }
    }

    const payWithPrepaidAccount = async () => {
      if (!prepaidAccount.value || prepaidAccount.value.balance < facture.value.montantTotal) {
        error('Solde insuffisant ou compte indisponible');
        return;
      }

      paying.value = true;
      try {
        console.log(' Débit compte prépayé pour facture:', facture.value.id);

        const response = await ApiService.post(`/payments/prepaid`, {
          factureId: facture.value.id,
          acteurId: prepaidAccount.value.acteurId,
          amount: facture.value.montantTotal,
          paymentMethodType: 'PREPAID_ACCOUNT',
          comment: 'Paiement via compte prépayé'
        });

        console.log(' Réponse paiement:', response.data);

        await new Promise(resolve => setTimeout(resolve, 1000));

        success(' Paiement effectué avec succès !');

        showPaymentModal.value = false;
        showSuccessModal.value = true;

        // Recharger le solde
        await loadPrepaidAccount();

      } catch (err: any) {
        console.error(' Erreur paiement prépayé:', err);
        error(err.response?.data?.message || 'Erreur lors du paiement');
      } finally {
        paying.value = false;
      }
    };

    const redirectToPaymentMethod = async (method: 'kkiapay' | 'stripe' | 'paypal') => {
      try {
        // Stocker les infos en session
        sessionStorage.setItem('pendingPaymentBescId', bescId);
        sessionStorage.setItem('pendingPaymentFactureId', facture.value.id);

        if (method === 'paypal') {
          console.log(' [PAYPAL] Création de la commande PayPal pour BESC:', bescId);

          const { data } = await ApiService.post(
            `/besc/${bescId}/payment/paypal/create-order`,
            { comment: '' }
          );

          console.log(' [PAYPAL] Commande créée:', data.data);

          window.location.href = data.data.approvalUrl;
          return;
        }

        if (method === 'stripe') {
          sessionStorage.setItem('pendingPaymentBescId', bescId);
          router.push(`/paiement-stripe/${bescId}`);
          return;
        }

        if (method === 'kkiapay') {
          sessionStorage.setItem('pendingPaymentBescId', bescId);
          router.push(`/paiement-kkiapay/${bescId}`);
          return;
        }

      } catch (err: any) {
        console.error(' Erreur lancement paiement:', err);
        error(err.response?.data?.message || 'Impossible de lancer le paiement');
      }
    }

    const cancelPayment = () => {
      showPaymentModal.value = false
      router.push({ name: 'ListeBesc' })
    }

    const goToList = () => {
      showSuccessModal.value = false
      resetBescWizard()
      router.push({ name: 'ListeBesc' })
    }

    const formatEuro = (amount?: number | string) => {
      if (amount == null) return '— €';

      const num = typeof amount === 'string' ? parseFloat(amount) : amount;
      if (isNaN(num)) return '— €';

      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
      }).format(num);
    };


    const formatDate = (dateStr: string) => {
      return new Date(dateStr).toLocaleDateString('fr-FR')
    }

    onMounted(async () => {
      await loadTypes();
      
      // Load BESC progression
      await loadBescProgressionFromAPI(bescId);

      // DÉTECTION DU RETOUR DE PAIEMENT (PayPal, KKiaPay, Stripe)
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');           // PayPal
      const txId = urlParams.get('transaction_id');   // KKiaPay
      const paymentIntent = urlParams.get('payment_intent_client_secret'); // Stripe

      if (token) {
        // === RETOUR PAYPAL ===
        console.log(' [PAYPAL] Retour de PayPal détecté - Token:', token);

        Swal.fire({
          title: ' Finalisation du paiement PayPal...',
          html: 'Veuillez patienter pendant la capture du paiement.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          // Capture du paiement PayPal
          const response = await ApiService.post(
            `/besc/${bescId}/payment/paypal/capture`,
            { orderID: token }
          );

          console.log(' [PAYPAL] Capture réussie:', response.data);

          Swal.close();

          // Charger les infos actualisées du BESC
          const { data: bescData } = await ApiService.get(`/besc/${bescId}`);
          facture.value = bescData.data.facture;

          // Afficher le modal de succès avec impressions
          showPaymentModal.value = false;
          showSuccessModal.value = true;

          // Nettoyer l'URL
          window.history.replaceState({}, '', window.location.pathname);

        } catch (err: any) {
          console.error(' [PAYPAL] Erreur capture:', err);
          Swal.fire({
            icon: 'error',
            title: 'Erreur de paiement',
            text: err.response?.data?.message || 'La capture du paiement PayPal a échoué',
            confirmButtonText: 'Retour'
          }).then(() => {
            router.push({ name: 'ListeBesc' });
          });
        }
      }
      else if (txId) {
        // === RETOUR KKIAPAY ===
        console.log(' [KKIAPAY] Retour de KKiaPay détecté - Transaction ID:', txId);

        Swal.fire({
          title: ' Vérification du paiement KKiaPay...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          const response = await ApiService.post(
            `/besc/${bescId}/payment/kkiapay/verify`,
            { transactionId: txId }
          );

          console.log(' [KKIAPAY] Vérification réussie:', response.data);

          Swal.close();

          const { data: bescData } = await ApiService.get(`/besc/${bescId}`);
          facture.value = bescData.data.facture;

          showPaymentModal.value = false;
          showSuccessModal.value = true;

          window.history.replaceState({}, '', window.location.pathname);

        } catch (err: any) {
          console.error(' [KKIAPAY] Erreur vérification:', err);
          Swal.fire({
            icon: 'error',
            title: 'Erreur de paiement',
            text: err.response?.data?.message || 'La vérification du paiement KKiaPay a échoué',
            confirmButtonText: 'Retour'
          }).then(() => {
            router.push({ name: 'ListeBesc' });
          });
        }
      }
    });

    // IMPRESSION DIRECTE DU BESC COMPLET
    const printBESC = async () => {
      printingBESC.value = true
      try {
        const response = await ApiService.getFile(`/besc/${bescId}/download-draft`)
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.src = url
        document.body.appendChild(iframe)

        iframe.onload = () => {
          iframe.contentWindow?.focus()
          iframe.contentWindow?.print()
        }

        window.addEventListener('focus', () => {
          setTimeout(() => {
            if (document.body.contains(iframe)) document.body.removeChild(iframe)
            window.URL.revokeObjectURL(url)
          }, 10000)
        }, { once: true })
      } catch (err) {
        error('Erreur lors de l\'impression du BESC')
      } finally {
        printingBESC.value = false
      }
    }

    // IMPRESSION DIRECTE DE LA FACTURE
    const printFacture = async () => {
      printingFacture.value = true
      try {
        // À adapter si ton endpoint est différent (ex: /besc/{id}/invoice-pdf)
        const response = await ApiService.getFile(`/besc/${bescId}/download-invoice`)
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.src = url
        document.body.appendChild(iframe)

        iframe.onload = () => {
          iframe.contentWindow?.focus()
          iframe.contentWindow?.print()
        }

        window.addEventListener('focus', () => {
          setTimeout(() => {
            if (document.body.contains(iframe)) document.body.removeChild(iframe)
            window.URL.revokeObjectURL(url)
          }, 10000)
        }, { once: true })
      } catch (err) {
        error('Erreur lors de l\'impression de la facture')
      } finally {
        printingFacture.value = false
      }
    }

    onMounted(() => {
      loadTypes()
    })

    return {
      bescId,
      typeDocuments,
      pieces,
      submitting,
      loading,
      hasAllDocuments,
      canAddPiece,
      handleFile,
      addPiece,
      removePiece,
      saveDraft,
      showPaymentModal,
      showSuccessModal,
      facture,
      prepaidAccount,
      paying,
      goToRecap,
      payWithPrepaidAccount,
      redirectToPaymentMethod,
      cancelPayment,
      goToList,
      documentManquant,
      formatEuro,
      formatDate,
      previewDraft,
      printBESC,
      printFacture,
      printingBESC,
      printingFacture
    }
  }
})
</script>

<style scoped>
.border-danger {
  border-color: #dc3545 !important;
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed !important;
}

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1040;
}

/* Styles du modal paiement (inchangés) */
.payment-modal-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.payment-header {
  background: linear-gradient(135deg, #0a59a4 0%, #0d6ec9 100%);
  color: white;
  padding: 2rem;
  border-radius: 16px 16px 0 0;
  margin: -1.5rem -1.5rem 2rem -1.5rem;
  text-align: center;
}

.payment-header h2 {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
}

.payment-header p {
  margin: 0.5rem 0 0 0;
  opacity: 0.95;
  font-size: 0.95rem;
}

.amount-display {
  background: rgba(255, 255, 255, 0.15);
  padding: 1rem;
  border-radius: 12px;
  margin: 1rem 0;
  color: white;
  font-size: 1.8rem;
  font-weight: 700;
}

.payment-methods-title {
  text-align: center;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin: 2rem 0 1.5rem 0;
}

.payment-methods-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
  padding: 0 1rem;
}

.payment-method-card {
  position: relative;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 2rem 1.5rem;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.payment-method-card:hover {
  transform: translateY(-8px);
  border-color: #0a59a4;
  box-shadow: 0 20px 40px rgba(10, 89, 164, 0.15);
}

.payment-method-card.recommended::before {
  content: '⭐ Recommandé';
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  padding: 0.35rem 1rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.payment-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 1rem;
  background: #f8fafc;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.payment-method-card:hover .payment-icon-wrapper {
  background: #0a59a4;
  transform: scale(1.1);
}

.payment-method-name {
  font-weight: 700;
  font-size: 1.1rem;
  color: #1e293b;
  margin: 0.75rem 0 0.5rem 0;
}

.payment-method-desc {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

@media (max-width: 768px) {
  .payment-methods-grid {
    grid-template-columns: 1fr;
    padding: 0;
  }

  .payment-header h2 {
    font-size: 1.5rem;
  }
}
</style>